import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import Vue from 'vue';
import cart from './modules/cart';

// Load Vuex
Vue.use(Vuex);
// Create store
export default new Vuex.Store({
  modules: {
    cart
  },
  plugins: [createPersistedState()]
});